var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0264 49.807C20.6993 37.0207 29.5029 30.0387 34.5501 26.6738H46.1167C58.5116 34.8756 60.1941 46.7226 59.9838 51.9101C59.1425 60.8269 51.3742 63.0561 47.5888 62.6355H27.8075C20.0264 60.7427 19.8862 52.3307 20.0264 49.807Z",
    fill: "#D68D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4452 17.4691C30.931 16.6279 30.6927 17.8196 30.7628 18.5206C30.7628 24.4932 34.9688 27.5986 37.0718 28.4048H40.1212C47.0191 29.3301 49.024 22.2009 49.1642 18.5206C49.3324 16.8382 47.4178 16.654 46.8508 17.4691C45.5782 18.8622 44.3056 19.3879 42.8443 18.5206C41.1619 16.67 37.9831 17.7495 37.0718 18.5206C34.8847 19.3618 33.0761 18.1701 32.4452 17.4691Z",
    fill: "#B16F0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8379 59.6915C51.5718 59.6214 56.8294 57.4623 55.9882 49.3867C54.9366 52.2608 52.0345 58.3456 48.8379 59.6915Z",
    fill: "#F0AF4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0034 21.2061C33.6511 22.4844 34.0638 25.5358 38.5329 27.5151C37.0231 26.0306 34.0034 22.6905 34.0034 21.2061Z",
    fill: "#D99937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0068 21.2061C46.3591 22.4844 45.9464 25.5358 41.4774 27.5151C42.9872 26.0306 46.0068 22.6905 46.0068 21.2061Z",
    fill: "#D99937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.374 26.8843C39.6194 26.0431 39.9629 23.898 39.374 22.0474C40.2503 23.2741 41.477 25.959 39.374 26.8843Z",
    fill: "#D99937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagging);
export default __webpack_public_path__ + "static/media/bagging.f11c9134bd89c1fd066cd91c1ffa2d83.svg";
export { ForwardRef as ReactComponent };